import { TGetContext } from '@api/lendingAPI/lapi.types';

import { getBanksFromContext } from '../../BankSelectionModal/getBanksFromContext';

export const getMigratedProviderName = (
    context: TGetContext['data'],
    successorBankId: string | undefined
): string | undefined => {
    if (!successorBankId) return undefined;

    return getBanksFromContext(context).find(
        (bank) => bank.bank_id === successorBankId
    )?.bank_name;
};
